var E;
// @__NO_SIDE_EFFECTS__
function Ee(t) {
  return {
    lang: (t == null ? void 0 : t.lang) ?? (E == null ? void 0 : E.lang),
    message: t == null ? void 0 : t.message,
    abortEarly: (t == null ? void 0 : t.abortEarly) ?? (E == null ? void 0 : E.abortEarly),
    abortPipeEarly: (t == null ? void 0 : t.abortPipeEarly) ?? (E == null ? void 0 : E.abortPipeEarly)
  };
}
var N;
// @__NO_SIDE_EFFECTS__
function nt(t) {
  return N == null ? void 0 : N.get(t);
}
var C;
// @__NO_SIDE_EFFECTS__
function rt(t) {
  return C == null ? void 0 : C.get(t);
}
var U;
// @__NO_SIDE_EFFECTS__
function st(t, e) {
  var n;
  return (n = U == null ? void 0 : U.get(t)) == null ? void 0 : n.get(e);
}
// @__NO_SIDE_EFFECTS__
function it(t) {
  var n, r;
  const e = typeof t;
  return e === "string" ? `"${t}"` : e === "number" || e === "bigint" || e === "boolean" ? `${t}` : e === "object" || e === "function" ? (t && ((r = (n = Object.getPrototypeOf(t)) == null ? void 0 : n.constructor) == null ? void 0 : r.name)) ?? "null" : e;
}
function A(t, e, n, r, s) {
  const a = s && "input" in s ? s.input : n.value, i = (s == null ? void 0 : s.expected) ?? t.expects ?? null, u = (s == null ? void 0 : s.received) ?? /* @__PURE__ */ it(a), o = {
    kind: t.kind,
    type: t.type,
    input: a,
    expected: i,
    received: u,
    message: `Invalid ${e}: ${i ? `Expected ${i} but r` : "R"}eceived ${u}`,
    requirement: t.requirement,
    path: s == null ? void 0 : s.path,
    issues: s == null ? void 0 : s.issues,
    lang: r.lang,
    abortEarly: r.abortEarly,
    abortPipeEarly: r.abortPipeEarly
  }, c = t.kind === "schema", p = (s == null ? void 0 : s.message) ?? t.message ?? /* @__PURE__ */ st(t.reference, o.lang) ?? (c ? /* @__PURE__ */ rt(o.lang) : null) ?? r.message ?? /* @__PURE__ */ nt(o.lang);
  p && (o.message = typeof p == "function" ? (
    // @ts-expect-error
    p(o)
  ) : p), c && (n.typed = !1), n.issues ? n.issues.push(o) : n.issues = [o];
}
// @__NO_SIDE_EFFECTS__
function w(t) {
  return {
    version: 1,
    vendor: "valibot",
    validate(e) {
      return t["~run"]({ value: e }, /* @__PURE__ */ Ee());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function at(t, e) {
  return Object.hasOwn(t, e) && e !== "__proto__" && e !== "prototype" && e !== "constructor";
}
var ot = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(t) {
    super(t[0].message), this.name = "ValiError", this.issues = t;
  }
};
// @__NO_SIDE_EFFECTS__
function Z(t, e, n) {
  return typeof t.default == "function" ? (
    // @ts-expect-error
    t.default(e, n)
  ) : (
    // @ts-expect-error
    t.default
  );
}
// @__NO_SIDE_EFFECTS__
function D(t, e) {
  return !t["~run"]({ value: e }, { abortEarly: !0 }).issues;
}
// @__NO_SIDE_EFFECTS__
function ke() {
  return {
    kind: "schema",
    type: "any",
    reference: ke,
    expects: "any",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(t) {
      return t.typed = !0, t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function z(t) {
  return {
    kind: "schema",
    type: "boolean",
    reference: z,
    expects: "boolean",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(e, n) {
      return typeof e.value == "boolean" ? e.typed = !0 : A(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function X(t) {
  return {
    kind: "schema",
    type: "function",
    reference: X,
    expects: "Function",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(e, n) {
      return typeof e.value == "function" ? e.typed = !0 : A(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function v(t, e) {
  return {
    kind: "schema",
    type: "loose_object",
    reference: v,
    expects: "Object",
    async: !1,
    entries: t,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(n, r) {
      var a;
      const s = n.value;
      if (s && typeof s == "object") {
        n.typed = !0, n.value = {};
        for (const i in this.entries) {
          const u = this.entries[i];
          if (i in s || (u.type === "exact_optional" || u.type === "optional" || u.type === "nullish") && // @ts-expect-error
          u.default !== void 0) {
            const o = i in s ? (
              // @ts-expect-error
              s[i]
            ) : /* @__PURE__ */ Z(u), c = u["~run"]({ value: o }, r);
            if (c.issues) {
              const p = {
                type: "object",
                origin: "value",
                input: s,
                key: i,
                value: o
              };
              for (const l of c.issues)
                l.path ? l.path.unshift(p) : l.path = [p], (a = n.issues) == null || a.push(l);
              if (n.issues || (n.issues = c.issues), r.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            c.typed || (n.typed = !1), n.value[i] = c.value;
          } else if (u.type !== "exact_optional" && u.type !== "optional" && u.type !== "nullish" && (A(this, "key", n, r, {
            input: void 0,
            expected: `"${i}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: s,
                key: i,
                // @ts-expect-error
                value: s[i]
              }
            ]
          }), r.abortEarly))
            break;
        }
        if (!n.issues || !r.abortEarly)
          for (const i in s)
            /* @__PURE__ */ at(s, i) && !(i in this.entries) && (n.value[i] = s[i]);
      } else
        A(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function T(t, e) {
  return {
    kind: "schema",
    type: "nullish",
    reference: T,
    expects: `(${t.expects} | null | undefined)`,
    async: !1,
    wrapped: t,
    default: e,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(n, r) {
      return (n.value === null || n.value === void 0) && (this.default !== void 0 && (n.value = /* @__PURE__ */ Z(this, n, r)), n.value === null || n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function G(t) {
  return {
    kind: "schema",
    type: "number",
    reference: G,
    expects: "number",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(e, n) {
      return typeof e.value == "number" && !isNaN(e.value) ? e.typed = !0 : A(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function B(t, e) {
  return {
    kind: "schema",
    type: "optional",
    reference: B,
    expects: `(${t.expects} | undefined)`,
    async: !1,
    wrapped: t,
    default: e,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(n, r) {
      return n.value === void 0 && (this.default !== void 0 && (n.value = /* @__PURE__ */ Z(this, n, r)), n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function k(t) {
  return {
    kind: "schema",
    type: "string",
    reference: k,
    expects: "string",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(e, n) {
      return typeof e.value == "string" ? e.typed = !0 : A(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function xe() {
  return {
    kind: "schema",
    type: "unknown",
    reference: xe,
    expects: "unknown",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(t) {
      return t.typed = !0, t;
    }
  };
}
function F(t, e, n) {
  const r = t["~run"]({ value: e }, /* @__PURE__ */ Ee(n));
  if (r.issues)
    throw new ot(r.issues);
  return r.value;
}
// @__NO_SIDE_EFFECTS__
function $e(...t) {
  return {
    ...t[0],
    pipe: t,
    get "~standard"() {
      return /* @__PURE__ */ w(this);
    },
    "~run"(e, n) {
      for (const r of t)
        if (r.kind !== "metadata") {
          if (e.issues && (r.kind === "schema" || r.kind === "transformation")) {
            e.typed = !1;
            break;
          }
          (!e.issues || !n.abortEarly && !n.abortPipeEarly) && (e = r["~run"](e, n));
        }
      return e;
    }
  };
}
function Pe(t) {
  return /* @__PURE__ */ D(
    /* @__PURE__ */ v({ TelegramWebviewProxy: /* @__PURE__ */ v({ postEvent: /* @__PURE__ */ X() }) }),
    t
  );
}
function Se() {
  try {
    return window.self !== window.top;
  } catch {
    return !0;
  }
}
var ut = Object.defineProperty, ct = (t, e, n) => e in t ? ut(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, ce = (t, e, n) => ct(t, typeof e != "symbol" ? e + "" : e, n);
function pt(t) {
  return (e) => e instanceof t;
}
function je(t, e) {
  e || (e = []);
  class n extends Error {
    constructor(...s) {
      const a = typeof e == "function" ? e(...s) : typeof e == "string" ? [e] : e || [];
      super(...a), this.name = t;
    }
  }
  return Object.defineProperty(n, "name", { value: t }), [n, pt(n)];
}
const [lt, cn] = je("CancelledError", "Promise was canceled"), [ft, pn] = je(
  "TimeoutError",
  (t, e) => [`Timeout reached: ${t}ms`, { cause: e }]
), Ae = Symbol("Resolved");
function pe(t) {
  return Array.isArray(t) && t[0] === Ae;
}
function dt(t) {
  return [Ae, t];
}
function le(t, e) {
  return t.reject = e.reject, t.abort = e.abort, t;
}
let qe = class K extends Promise {
  constructor(e, n) {
    let r, s;
    super((a, i) => {
      let u, o;
      typeof e == "function" ? (u = e, o = n) : o = e;
      const c = [], p = (f) => (...j) => {
        const I = f(...j);
        return c.forEach((tt) => tt()), I;
      }, l = new AbortController(), { signal: y } = l;
      s = (f) => {
        !y.aborted && l.abort(f);
      };
      const b = () => y.reason, P = (f) => {
        const j = () => {
          f(b());
        };
        y.addEventListener("abort", j, !0);
        const I = () => {
          y.removeEventListener("abort", j, !0);
        };
        return c.push(I), I;
      }, et = p((f) => {
        a(f), s(dt(f));
      });
      r = p((f) => {
        i(f), s(f);
      }), o || (o = {});
      const { abortSignal: S, rejectOnAbort: ie = !0 } = o;
      if (S)
        if (S.aborted) {
          const { reason: f } = S;
          if (ie)
            return r(f);
          s(f);
        } else {
          const f = () => {
            s(S.reason);
          };
          S.addEventListener("abort", f), c.push(() => {
            S.removeEventListener("abort", f);
          });
        }
      ie && P(i);
      const { timeout: R } = o;
      if (R) {
        const f = setTimeout(() => {
          s(new ft(R));
        }, R);
        c.push(() => {
          clearTimeout(f);
        });
      }
      const ae = () => y.aborted, oe = () => pe(b()), ue = () => {
        const f = b();
        return pe(f) ? f[1] : void 0;
      };
      try {
        const f = u && u(et, r, {
          abortReason: b,
          abortSignal: y,
          isAborted: ae,
          isResolved: oe,
          onAborted: P,
          onResolved: (j) => P(() => {
            oe() && j(ue());
          }),
          resolved: ue,
          throwIfAborted() {
            if (ae())
              throw b();
          }
        });
        f instanceof Promise && f.catch(r);
      } catch (f) {
        r(f);
      }
    }), ce(this, "abort"), ce(this, "reject"), this.abort = s, this.reject = r;
  }
  /**
   * Creates a new AbortablePromise instance using an executor, resolving the promise when a result
   * was returned.
   * @param fn - function returning promise result.
   * @param options - additional options.
   */
  static fn(e, n) {
    return new K(async (r, s, a) => {
      try {
        r(await e(a));
      } catch (i) {
        s(i);
      }
    }, n);
  }
  static resolve(e) {
    return this.fn(() => e);
  }
  /**
   * @see Promise.reject
   */
  static reject(e) {
    return new K((n, r) => {
      r(e);
    });
  }
  /**
   * Aborts the promise with the cancel error.
   */
  cancel() {
    this.abort(new lt());
  }
  /**
   * @see Promise.catch
   */
  catch(e) {
    return this.then(void 0, e);
  }
  /**
   * @see Promise.finally
   */
  finally(e) {
    return le(super.finally(e), this);
  }
  /**
   * @see Promise.then
   */
  then(e, n) {
    return le(super.then(e, n), this);
  }
};
function _t(t) {
  return t.replace(/_[a-z]/g, (e) => e[1].toUpperCase());
}
function yt(t) {
  return Object.entries(t).reduce((e, [n, r]) => (e[_t(n)] = r, e), {});
}
function Y(t) {
  const e = yt(t);
  for (const n in e) {
    const r = e[n];
    r && typeof r == "object" && !(r instanceof Date) && (e[n] = Array.isArray(r) ? r.map(Y) : Y(r));
  }
  return e;
}
function Me(t) {
  return `tapps/${t}`;
}
function Te(t, e) {
  sessionStorage.setItem(Me(t), JSON.stringify(e));
}
function bt(t) {
  const e = sessionStorage.getItem(Me(t));
  try {
    return e ? JSON.parse(e) : void 0;
  } catch {
  }
}
function ht(...t) {
  const e = t.flat(1);
  return [
    e.push.bind(e),
    () => {
      e.forEach((n) => {
        n();
      });
    }
  ];
}
// @__NO_SIDE_EFFECTS__
function mt(t, e) {
  e || (e = {});
  const {
    textColor: n,
    bgColor: r,
    shouldLog: s
  } = e, a = s === void 0 ? !0 : s, i = typeof a == "boolean" ? () => a : a;
  function u(o, c, ...p) {
    if (c || i()) {
      const l = "font-weight:bold;padding:0 5px;border-radius:5px";
      console[o](
        `%c${Intl.DateTimeFormat("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          fractionalSecondDigits: 3,
          timeZone: "UTC"
        }).format(/* @__PURE__ */ new Date())}%c / %c${t}`,
        `${l};background-color: lightblue;color:black`,
        "",
        `${l};${n ? `color:${n};` : ""}${r ? `background-color:${r}` : ""}`,
        ...p
      );
    }
  }
  return [u.bind(void 0, "log"), u.bind(void 0, "error")];
}
// @__NO_SIDE_EFFECTS__
function Le(t) {
  return {
    lang: (t == null ? void 0 : t.lang) ?? void 0,
    message: t == null ? void 0 : t.message,
    abortEarly: (t == null ? void 0 : t.abortEarly) ?? void 0,
    abortPipeEarly: (t == null ? void 0 : t.abortPipeEarly) ?? void 0
  };
}
// @__NO_SIDE_EFFECTS__
function gt(t, e) {
  var n;
  return (n = void 0) == null ? void 0 : n.get(e);
}
// @__NO_SIDE_EFFECTS__
function vt(t) {
  var e, n;
  const r = typeof t;
  return r === "string" ? `"${t}"` : r === "number" || r === "bigint" || r === "boolean" ? `${t}` : r === "object" || r === "function" ? (t && ((n = (e = Object.getPrototypeOf(t)) == null ? void 0 : e.constructor) == null ? void 0 : n.name)) ?? "null" : r;
}
function m(t, e, n, r, s) {
  const a = s && "input" in s ? s.input : n.value, i = (s == null ? void 0 : s.expected) ?? t.expects ?? null, u = (s == null ? void 0 : s.received) ?? /* @__PURE__ */ vt(a), o = {
    kind: t.kind,
    type: t.type,
    input: a,
    expected: i,
    received: u,
    message: `Invalid ${e}: ${i ? `Expected ${i} but r` : "R"}eceived ${u}`,
    requirement: t.requirement,
    path: s == null ? void 0 : s.path,
    issues: s == null ? void 0 : s.issues,
    lang: r.lang,
    abortEarly: r.abortEarly,
    abortPipeEarly: r.abortPipeEarly
  }, c = t.kind === "schema", p = (s == null ? void 0 : s.message) ?? t.message ?? /* @__PURE__ */ gt(t.reference, o.lang) ?? (c ? (o.lang, void 0) : null) ?? r.message ?? (o.lang, void 0);
  p && (o.message = typeof p == "function" ? (
    // @ts-expect-error
    p(o)
  ) : p), c && (n.typed = !1), n.issues ? n.issues.push(o) : n.issues = [o];
}
// @__NO_SIDE_EFFECTS__
function g(t) {
  return {
    version: 1,
    vendor: "valibot",
    validate(e) {
      return t["~run"]({ value: e }, /* @__PURE__ */ Le());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ie(t, e) {
  return Object.hasOwn(t, e) && e !== "__proto__" && e !== "prototype" && e !== "constructor";
}
// @__NO_SIDE_EFFECTS__
function wt(t, e) {
  const n = [...new Set(t)];
  return n.length > 1 ? `(${n.join(` ${e} `)})` : n[0] ?? "never";
}
var Et = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(t) {
    super(t[0].message), this.name = "ValiError", this.issues = t;
  }
};
// @__NO_SIDE_EFFECTS__
function We(t, e) {
  return {
    kind: "validation",
    type: "check",
    reference: We,
    async: !1,
    expects: null,
    requirement: t,
    message: e,
    "~run"(n, r) {
      return n.typed && !this.requirement(n.value) && m(this, "input", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function De(t) {
  return {
    kind: "validation",
    type: "integer",
    reference: De,
    async: !1,
    expects: null,
    requirement: Number.isInteger,
    message: t,
    "~run"(e, n) {
      return e.typed && !this.requirement(e.value) && m(this, "integer", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function x(t) {
  return {
    kind: "transformation",
    type: "transform",
    reference: x,
    async: !1,
    operation: t,
    "~run"(e) {
      return e.value = this.operation(e.value), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Re(t, e, n) {
  return typeof t.default == "function" ? (
    // @ts-expect-error
    t.default(e, n)
  ) : (
    // @ts-expect-error
    t.default
  );
}
// @__NO_SIDE_EFFECTS__
function kt(t, e) {
  return !t["~run"]({ value: e }, { abortEarly: !0 }).issues;
}
// @__NO_SIDE_EFFECTS__
function L(t) {
  return {
    kind: "schema",
    type: "boolean",
    reference: L,
    expects: "boolean",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ g(this);
    },
    "~run"(e, n) {
      return typeof e.value == "boolean" ? e.typed = !0 : m(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ne(t) {
  return {
    kind: "schema",
    type: "date",
    reference: Ne,
    expects: "Date",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ g(this);
    },
    "~run"(e, n) {
      return e.value instanceof Date ? isNaN(e.value) ? m(this, "type", e, n, {
        received: '"Invalid Date"'
      }) : e.typed = !0 : m(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ce(t, e) {
  return {
    kind: "schema",
    type: "instance",
    reference: Ce,
    expects: t.name,
    async: !1,
    class: t,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ g(this);
    },
    "~run"(n, r) {
      return n.value instanceof this.class ? n.typed = !0 : m(this, "type", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function V(t) {
  return {
    kind: "schema",
    type: "lazy",
    reference: V,
    expects: "unknown",
    async: !1,
    getter: t,
    get "~standard"() {
      return /* @__PURE__ */ g(this);
    },
    "~run"(e, n) {
      return this.getter(e.value)["~run"](e, n);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function q(t, e) {
  return {
    kind: "schema",
    type: "loose_object",
    reference: q,
    expects: "Object",
    async: !1,
    entries: t,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ g(this);
    },
    "~run"(n, r) {
      var s;
      const a = n.value;
      if (a && typeof a == "object") {
        n.typed = !0, n.value = {};
        for (const i in this.entries) {
          const u = this.entries[i];
          if (i in a || (u.type === "exact_optional" || u.type === "optional" || u.type === "nullish") && // @ts-expect-error
          u.default !== void 0) {
            const o = i in a ? (
              // @ts-expect-error
              a[i]
            ) : /* @__PURE__ */ Re(u), c = u["~run"]({ value: o }, r);
            if (c.issues) {
              const p = {
                type: "object",
                origin: "value",
                input: a,
                key: i,
                value: o
              };
              for (const l of c.issues)
                l.path ? l.path.unshift(p) : l.path = [p], (s = n.issues) == null || s.push(l);
              if (n.issues || (n.issues = c.issues), r.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            c.typed || (n.typed = !1), n.value[i] = c.value;
          } else if (u.type !== "exact_optional" && u.type !== "optional" && u.type !== "nullish" && (m(this, "key", n, r, {
            input: void 0,
            expected: `"${i}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: a,
                key: i,
                // @ts-expect-error
                value: a[i]
              }
            ]
          }), r.abortEarly))
            break;
        }
        if (!n.issues || !r.abortEarly)
          for (const i in a)
            /* @__PURE__ */ Ie(a, i) && !(i in this.entries) && (n.value[i] = a[i]);
      } else
        m(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ee(t) {
  return {
    kind: "schema",
    type: "number",
    reference: ee,
    expects: "number",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ g(this);
    },
    "~run"(e, n) {
      return typeof e.value == "number" && !isNaN(e.value) ? e.typed = !0 : m(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function _(t, e) {
  return {
    kind: "schema",
    type: "optional",
    reference: _,
    expects: `(${t.expects} | undefined)`,
    async: !1,
    wrapped: t,
    default: e,
    get "~standard"() {
      return /* @__PURE__ */ g(this);
    },
    "~run"(n, r) {
      return n.value === void 0 && (this.default !== void 0 && (n.value = /* @__PURE__ */ Re(this, n, r)), n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ue(t, e, n) {
  return {
    kind: "schema",
    type: "record",
    reference: Ue,
    expects: "Object",
    async: !1,
    key: t,
    value: e,
    message: n,
    get "~standard"() {
      return /* @__PURE__ */ g(this);
    },
    "~run"(r, s) {
      var a, i;
      const u = r.value;
      if (u && typeof u == "object") {
        r.typed = !0, r.value = {};
        for (const o in u)
          if (/* @__PURE__ */ Ie(u, o)) {
            const c = u[o], p = this.key["~run"]({ value: o }, s);
            if (p.issues) {
              const y = {
                type: "object",
                origin: "key",
                input: u,
                key: o,
                value: c
              };
              for (const b of p.issues)
                b.path = [y], (a = r.issues) == null || a.push(b);
              if (r.issues || (r.issues = p.issues), s.abortEarly) {
                r.typed = !1;
                break;
              }
            }
            const l = this.value["~run"](
              { value: c },
              s
            );
            if (l.issues) {
              const y = {
                type: "object",
                origin: "value",
                input: u,
                key: o,
                value: c
              };
              for (const b of l.issues)
                b.path ? b.path.unshift(y) : b.path = [y], (i = r.issues) == null || i.push(b);
              if (r.issues || (r.issues = l.issues), s.abortEarly) {
                r.typed = !1;
                break;
              }
            }
            (!p.typed || !l.typed) && (r.typed = !1), p.typed && (r.value[p.value] = l.value);
          }
      } else
        m(this, "type", r, s);
      return r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function d(t) {
  return {
    kind: "schema",
    type: "string",
    reference: d,
    expects: "string",
    async: !1,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ g(this);
    },
    "~run"(e, n) {
      return typeof e.value == "string" ? e.typed = !0 : m(this, "type", e, n), e;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function fe(t) {
  let e;
  if (t)
    for (const n of t)
      e ? e.push(...n.issues) : e = n.issues;
  return e;
}
// @__NO_SIDE_EFFECTS__
function Oe(t, e) {
  return {
    kind: "schema",
    type: "union",
    reference: Oe,
    expects: /* @__PURE__ */ wt(
      t.map((n) => n.expects),
      "|"
    ),
    async: !1,
    options: t,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ g(this);
    },
    "~run"(n, r) {
      let s, a, i;
      for (const u of this.options) {
        const o = u["~run"]({ value: n.value }, r);
        if (o.typed)
          if (o.issues)
            a ? a.push(o) : a = [o];
          else {
            s = o;
            break;
          }
        else
          i ? i.push(o) : i = [o];
      }
      if (s)
        return s;
      if (a) {
        if (a.length === 1)
          return a[0];
        m(this, "type", n, r, {
          issues: /* @__PURE__ */ fe(a)
        }), n.typed = !0;
      } else {
        if ((i == null ? void 0 : i.length) === 1)
          return i[0];
        m(this, "type", n, r, {
          issues: /* @__PURE__ */ fe(i)
        });
      }
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Je() {
  return {
    kind: "schema",
    type: "unknown",
    reference: Je,
    expects: "unknown",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ g(this);
    },
    "~run"(t) {
      return t.typed = !0, t;
    }
  };
}
function ze(t, e, n) {
  const r = t["~run"]({ value: e }, /* @__PURE__ */ Le(n));
  if (r.issues)
    throw new Et(r.issues);
  return r.value;
}
// @__NO_SIDE_EFFECTS__
function $(...t) {
  return {
    ...t[0],
    pipe: t,
    get "~standard"() {
      return /* @__PURE__ */ g(this);
    },
    "~run"(e, n) {
      for (const r of t)
        if (r.kind !== "metadata") {
          if (e.issues && (r.kind === "schema" || r.kind === "transformation")) {
            e.typed = !1;
            break;
          }
          (!e.issues || !n.abortEarly && !n.abortPipeEarly) && (e = r["~run"](e, n));
        }
      return e;
    }
  };
}
function xt(t) {
  return t.replace(/_[a-z]/g, (e) => e[1].toUpperCase());
}
function $t(t) {
  return Object.entries(t).reduce((e, [n, r]) => (e[xt(n)] = r, e), {});
}
function H(t) {
  const e = $t(t);
  for (const n in e) {
    const r = e[n];
    r && typeof r == "object" && !(r instanceof Date) && (e[n] = Array.isArray(r) ? r.map(H) : H(r));
  }
  return e;
}
function te(t) {
  return /* @__PURE__ */ x((e) => t ? H(e) : e);
}
function Ge(t) {
  return (e) => /* @__PURE__ */ $(
    t,
    te(e)
  );
}
function Pt(t) {
  return (e, n) => ze(
    /* @__PURE__ */ $(t, te(n)),
    e
  );
}
function ne() {
  return /* @__PURE__ */ x(JSON.parse);
}
function re(t) {
  const e = Ge(t);
  return (n) => /* @__PURE__ */ $(
    /* @__PURE__ */ d(),
    ne(),
    e(n)
  );
}
function St(t) {
  return /* @__PURE__ */ x((e) => {
    const n = {};
    return new URLSearchParams(e).forEach((r, s) => {
      const a = n[s];
      Array.isArray(a) ? a.push(r) : a === void 0 ? n[s] = r : n[s] = [a, r];
    }), ze(t, n);
  });
}
function Be(t) {
  return (e) => /* @__PURE__ */ $(
    /* @__PURE__ */ Oe([/* @__PURE__ */ d(), /* @__PURE__ */ Ce(URLSearchParams)]),
    St(t),
    te(e)
  );
}
const de = /* @__PURE__ */ _(/* @__PURE__ */ V(() => Tt())), jt = /* @__PURE__ */ q({
  id: /* @__PURE__ */ ee(),
  photo_url: /* @__PURE__ */ _(/* @__PURE__ */ d()),
  type: /* @__PURE__ */ d(),
  title: /* @__PURE__ */ d(),
  username: /* @__PURE__ */ _(/* @__PURE__ */ d())
}), At = /* @__PURE__ */ q({
  added_to_attachment_menu: /* @__PURE__ */ _(/* @__PURE__ */ L()),
  allows_write_to_pm: /* @__PURE__ */ _(/* @__PURE__ */ L()),
  first_name: /* @__PURE__ */ d(),
  id: /* @__PURE__ */ ee(),
  is_bot: /* @__PURE__ */ _(/* @__PURE__ */ L()),
  is_premium: /* @__PURE__ */ _(/* @__PURE__ */ L()),
  last_name: /* @__PURE__ */ _(/* @__PURE__ */ d()),
  language_code: /* @__PURE__ */ _(/* @__PURE__ */ d()),
  photo_url: /* @__PURE__ */ _(/* @__PURE__ */ d()),
  username: /* @__PURE__ */ _(/* @__PURE__ */ d())
}), qt = /* @__PURE__ */ q({
  auth_date: /* @__PURE__ */ $(
    /* @__PURE__ */ d(),
    /* @__PURE__ */ x((t) => new Date(Number(t) * 1e3)),
    /* @__PURE__ */ Ne()
  ),
  can_send_after: /* @__PURE__ */ _(/* @__PURE__ */ $(/* @__PURE__ */ d(), /* @__PURE__ */ x(Number), /* @__PURE__ */ De())),
  chat: /* @__PURE__ */ _(/* @__PURE__ */ V(() => Mt())),
  chat_type: /* @__PURE__ */ _(/* @__PURE__ */ d()),
  chat_instance: /* @__PURE__ */ _(/* @__PURE__ */ d()),
  hash: /* @__PURE__ */ d(),
  query_id: /* @__PURE__ */ _(/* @__PURE__ */ d()),
  receiver: de,
  start_param: /* @__PURE__ */ _(/* @__PURE__ */ d()),
  signature: /* @__PURE__ */ d(),
  user: de
}), Mt = re(jt), Tt = re(At), Lt = Be(qt);
function It(t) {
  return /^#[\da-f]{6}$/i.test(t);
}
const Wt = Ge(
  /* @__PURE__ */ Ue(
    /* @__PURE__ */ d(),
    /* @__PURE__ */ $(/* @__PURE__ */ d(), /* @__PURE__ */ We(It), /* @__PURE__ */ x((t) => t))
  )
), O = /* @__PURE__ */ _(
  /* @__PURE__ */ $(/* @__PURE__ */ d(), /* @__PURE__ */ x((t) => t === "1"))
), _e = re(Wt()), Dt = /* @__PURE__ */ q({
  tgWebAppBotInline: O,
  tgWebAppData: /* @__PURE__ */ _(Lt()),
  tgWebAppDefaultColors: /* @__PURE__ */ _(_e()),
  tgWebAppFullscreen: O,
  tgWebAppPlatform: /* @__PURE__ */ d(),
  tgWebAppShowSettings: O,
  tgWebAppStartParam: /* @__PURE__ */ _(/* @__PURE__ */ d()),
  tgWebAppThemeParams: _e(),
  tgWebAppVersion: /* @__PURE__ */ d()
}), Fe = Be(Dt), Rt = Pt(Fe()), Ke = /* @__PURE__ */ q({
  eventType: /* @__PURE__ */ d(),
  eventData: /* @__PURE__ */ _(/* @__PURE__ */ Je())
});
function Ye(t, e) {
  return e || (e = (n, r) => JSON.stringify(r)), new URLSearchParams(
    Object.entries(t).reduce((n, [r, s]) => (Array.isArray(s) ? n.push(...s.map((a) => [r, String(a)])) : s != null && n.push([
      r,
      s instanceof Date ? (s.getTime() / 1e3 | 0).toString() : typeof s == "string" || typeof s == "number" ? String(s) : typeof s == "boolean" ? s ? "1" : "0" : e(r, s)
    ]), n), [])
  ).toString();
}
function Nt(t) {
  return Ye(t);
}
function Ct(t) {
  return Ye(t, (e, n) => e === "tgWebAppData" ? Nt(n) : JSON.stringify(n));
}
function He(t) {
  try {
    return /* @__PURE__ */ kt(Fe(), t);
  } catch {
    return !1;
  }
}
function Ut(t) {
  return { all: t = t || /* @__PURE__ */ new Map(), on: function(e, n) {
    var r = t.get(e);
    r ? r.push(n) : t.set(e, [n]);
  }, off: function(e, n) {
    var r = t.get(e);
    r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : t.set(e, []));
  }, emit: function(e, n) {
    var r = t.get(e);
    r && r.slice().map(function(s) {
      s(n);
    }), (r = t.get("*")) && r.slice().map(function(s) {
      s(e, n);
    });
  } };
}
function Ot(t, e) {
  const n = Ut(), r = /* @__PURE__ */ new Map(), s = (a, i, u) => {
    u || (u = !1);
    const o = r.get(a) || /* @__PURE__ */ new Map();
    r.set(a, o);
    const c = o.get(i) || [];
    o.set(i, c);
    const p = c.findIndex((l) => l[1] === u);
    p >= 0 && (n.off(a, c[p][0]), c.splice(p, 1), !c.length && o.delete(i), o.size || (r.delete(a), !r.size && e()));
  };
  return [
    function(i, u, o) {
      !r.size && t();
      function c() {
        s(i, u, o);
      }
      function p(...b) {
        o && c(), i === "*" ? u(b) : u(...b);
      }
      n.on(i, p);
      const l = r.get(i) || /* @__PURE__ */ new Map();
      r.set(i, l);
      const y = l.get(u) || [];
      return l.set(u, y), y.push([p, o || !1]), c;
    },
    s,
    // eslint-disable-next-line @typescript-eslint/unbound-method
    n.emit,
    function() {
      const i = n.all.size;
      n.all.clear(), r.clear(), i && e();
    }
  ];
}
function ye(t, e) {
  window.dispatchEvent(new MessageEvent("message", {
    data: JSON.stringify({ eventType: t, eventData: e }),
    // We specify window.parent to imitate the case, the parent iframe sent us this event.
    source: window.parent
  }));
}
let W = !1;
const [se, Jt] = /* @__PURE__ */ mt("Bridge", {
  bgColor: "#9147ff",
  textColor: "white",
  shouldLog() {
    return W;
  }
}), be = (t) => {
  se(!1, "Event received:", t);
};
function zt(t) {
  t !== W && (W = t, W ? Qe("*", be) : Bt("*", be));
}
const Gt = {
  clipboard_text_received: /* @__PURE__ */ v({
    req_id: /* @__PURE__ */ k(),
    data: /* @__PURE__ */ T(/* @__PURE__ */ k())
  }),
  custom_method_invoked: /* @__PURE__ */ v({
    req_id: /* @__PURE__ */ k(),
    result: /* @__PURE__ */ B(/* @__PURE__ */ xe()),
    error: /* @__PURE__ */ B(/* @__PURE__ */ k())
  }),
  popup_closed: /* @__PURE__ */ T(
    /* @__PURE__ */ v({ button_id: /* @__PURE__ */ T(/* @__PURE__ */ k(), () => {
    }) }),
    {}
  ),
  viewport_changed: /* @__PURE__ */ v({
    height: /* @__PURE__ */ G(),
    width: /* @__PURE__ */ T(/* @__PURE__ */ G(), () => window.innerWidth),
    is_state_stable: /* @__PURE__ */ z(),
    is_expanded: /* @__PURE__ */ z()
  })
};
function he(t) {
  if (t.source !== window.parent)
    return;
  let e;
  try {
    e = F(/* @__PURE__ */ $e(/* @__PURE__ */ k(), ne(), Ke), t.data);
  } catch {
    return;
  }
  const { eventType: n, eventData: r } = e, s = Gt[n];
  try {
    const a = s ? F(s, r) : r;
    Ft(n, a);
  } catch (a) {
    Jt(
      !0,
      [
        `An error occurred processing the "${n}" event from the Telegram application.`,
        "Please, file an issue here:",
        "https://github.com/Telegram-Mini-Apps/telegram-apps/issues/new/choose"
      ].join(`
`),
      e,
      a
    );
  }
}
const [
  Qe,
  Bt,
  Ft,
  Kt
] = Ot(
  () => {
    const t = window, e = { receiveEvent: ye };
    t.TelegramGameProxy_receiveEvent = ye, t.TelegramGameProxy = e, t.Telegram = { WebView: e }, window.addEventListener("message", he);
  },
  () => {
    ["TelegramGameProxy_receiveEvent", "TelegramGameProxy", "Telegram"].forEach((t) => {
      delete window[t];
    }), window.removeEventListener("message", he);
  }
);
function Yt(t) {
  return (e) => e instanceof t;
}
function M(t, e) {
  e || (e = []);
  class n extends Error {
    constructor(...s) {
      const a = typeof e == "function" ? e(...s) : typeof e == "string" ? [e] : e || [];
      super(...a), this.name = t;
    }
  }
  return Object.defineProperty(n, "name", { value: t }), [n, Yt(n)];
}
const [
  Ht,
  ln
] = M(
  "MethodUnsupportedError",
  (t, e) => [
    `Method "${t}" is unsupported in Mini Apps version ${e}`
  ]
), [
  Qt,
  fn
] = M(
  "MethodParameterUnsupportedError",
  (t, e, n) => [
    `Parameter "${e}" of "${t}" method is unsupported in Mini Apps version ${n}`
  ]
), Zt = [
  "Unable to retrieve launch parameters from any known source. Perhaps, you have opened your app outside Telegram?",
  "📖 Refer to docs for more information:",
  "https://docs.telegram-mini-apps.com/packages/telegram-apps-bridge/environment"
].join(`
`), [
  Xt,
  dn
] = M("LaunchParamsRetrieveError", Zt), [
  Vt,
  _n
] = M("InvalidLaunchParamsError", (t) => [
  `Invalid value for launch params: ${t}`
]), [en, yn] = M("UnknownEnvError"), [
  tn,
  bn
] = M(
  "InvokeCustomMethodError",
  (t) => [`Server returned error: ${t}`]
);
function nn(t, e) {
  e();
}
// @__NO_SIDE_EFFECTS__
function rn(t, e) {
  e || (e = {});
  const n = e.equals || Object.is;
  let r = [], s = t;
  const a = (c) => {
    if (!n(s, c)) {
      const p = s;
      s = c, nn(o, () => {
        [...r].forEach(([l, y]) => {
          l(c, p), y && u(l, !0);
        });
      });
    }
  };
  function i(c) {
    const p = typeof c != "object" ? { once: c } : c;
    return {
      once: p.once || !1,
      signal: p.signal || !1
    };
  }
  const u = (c, p) => {
    const l = i(p), y = r.findIndex(([b, P]) => b === c && P.once === l.once && P.signal === l.signal);
    y >= 0 && r.splice(y, 1);
  }, o = Object.assign(
    function() {
      return sn(o), s;
    },
    {
      destroy() {
        r = [];
      },
      set: a,
      reset() {
        a(t);
      },
      sub(c, p) {
        return r.push([c, i(p)]), () => u(c, p);
      },
      unsub: u,
      unsubAll() {
        r = r.filter((c) => c[1].signal);
      }
    }
  );
  return o;
}
const J = [];
function sn(t) {
  J.length && J[J.length - 1].add(t);
}
const Q = /* @__PURE__ */ rn("https://web.telegram.org");
function Ze(t, e) {
  se(!1, "Posting event:", e ? { eventType: t, eventData: e } : { eventType: t });
  const n = window, r = JSON.stringify({ eventType: t, eventData: e });
  if (Se())
    return n.parent.postMessage(r, Q());
  if (Pe(n)) {
    n.TelegramWebviewProxy.postEvent(t, JSON.stringify(e));
    return;
  }
  if (/* @__PURE__ */ D(/* @__PURE__ */ v({ external: /* @__PURE__ */ v({ notify: /* @__PURE__ */ X() }) }), n)) {
    n.external.notify(r);
    return;
  }
  throw new en();
}
function Xe(t, e, n) {
  n || (n = {});
  const { capture: r } = n, [s, a] = ht();
  return new qe((i) => {
    (Array.isArray(e) ? e : [e]).forEach((u) => {
      s(
        Qe(u, (o) => {
          (!r || (Array.isArray(e) ? r({
            event: u,
            payload: o
          }) : r(o))) && i(o);
        })
      );
    }), (n.postEvent || Ze)(t, n.params);
  }, n).finally(a);
}
const me = "launchParams";
function ge(t) {
  return t.replace(/^[^?#]*[?#]/, "").replace(/[?#]/g, "&");
}
function Ve() {
  for (const t of [
    // Try to retrieve launch parameters from the current location. This method can return
    // nothing in case, location was changed, and then the page was reloaded.
    () => ge(window.location.href),
    // Then, try using the lower level API - window.performance.
    () => {
      const e = performance.getEntriesByType("navigation")[0];
      return e && ge(e.name);
    },
    () => bt(me)
  ]) {
    const e = t();
    if (e && He(e))
      return Te(me, e), e;
  }
  throw new Xt();
}
function an(t) {
  const e = Rt(Ve());
  return t ? Y(e) : e;
}
function hn(t, e) {
  if (!t)
    try {
      return an(), !0;
    } catch {
      return !1;
    }
  return qe.fn(async (n) => {
    if (Pe(window))
      return !0;
    try {
      return await Xe("web_app_request_theme", "theme_changed", n), !0;
    } catch {
      return !1;
    }
  }, e || { timeout: 100 });
}
function mn({ launchParams: t, onEvent: e } = {}) {
  if (t) {
    const s = typeof t == "string" || t instanceof URLSearchParams ? t.toString() : (
      // Here we have to trick serializeLaunchParamsQuery into thinking, it serializes a valid
      // value. We are doing it because we are working with tgWebAppData presented as a
      // string, not an object as serializeLaunchParamsQuery requires.
      Ct({ ...t, tgWebAppData: void 0 }) + (t.tgWebAppData ? `&tgWebAppData=${encodeURIComponent(t.tgWebAppData.toString())}` : "")
    );
    if (!He(s))
      throw new Vt(s);
    Te("launchParams", s);
  }
  if (Se()) {
    const s = /* @__PURE__ */ $e(
      /* @__PURE__ */ k(),
      ne(),
      Ke
    ), a = window.parent.postMessage.bind(window.parent);
    window.parent.postMessage = (...i) => {
      const [u] = i, o = () => {
        a(...i);
      };
      if (/* @__PURE__ */ D(s, u) && e) {
        const c = F(s, u);
        e([c.eventType, c.eventData], o);
      } else
        o();
    };
    return;
  }
  const n = window.TelegramWebviewProxy || {}, { postEvent: r } = n;
  window.TelegramWebviewProxy = {
    ...n,
    postEvent(s, a) {
      const i = () => {
        r && r(s, a);
      };
      e ? e([s, a ? JSON.parse(a) : void 0], i) : i();
    }
  }, se(!1, "Environment was mocked by the mockTelegramEnv function");
}
function gn() {
  return new URLSearchParams(Ve()).get("tgWebAppData") || void 0;
}
function on(t) {
  return ({ req_id: e }) => e === t;
}
function ve(t) {
  return t.split(".").map(Number);
}
function un(t, e) {
  const n = ve(t), r = ve(e), s = Math.max(n.length, r.length);
  for (let a = 0; a < s; a += 1) {
    const i = n[a] || 0, u = r[a] || 0;
    if (i !== u)
      return i > u ? 1 : -1;
  }
  return 0;
}
function h(t, e) {
  return un(t, e) <= 0;
}
function we(t, e, n) {
  if (typeof n == "string") {
    if (t === "web_app_open_link") {
      if (e === "try_instant_view")
        return h("6.4", n);
      if (e === "try_browser")
        return h("7.6", n);
    }
    if (t === "web_app_set_header_color" && e === "color")
      return h("6.9", n);
    if (t === "web_app_close" && e === "return_back")
      return h("7.6", n);
    if (t === "web_app_setup_main_button" && e === "has_shine_effect")
      return h("7.10", n);
  }
  switch (t) {
    case "web_app_open_tg_link":
    case "web_app_open_invoice":
    case "web_app_setup_back_button":
    case "web_app_set_background_color":
    case "web_app_set_header_color":
    case "web_app_trigger_haptic_feedback":
      return h("6.1", e);
    case "web_app_open_popup":
      return h("6.2", e);
    case "web_app_close_scan_qr_popup":
    case "web_app_open_scan_qr_popup":
    case "web_app_read_text_from_clipboard":
      return h("6.4", e);
    case "web_app_switch_inline_query":
      return h("6.7", e);
    case "web_app_invoke_custom_method":
    case "web_app_request_write_access":
    case "web_app_request_phone":
      return h("6.9", e);
    case "web_app_setup_settings_button":
      return h("6.10", e);
    case "web_app_biometry_get_info":
    case "web_app_biometry_open_settings":
    case "web_app_biometry_request_access":
    case "web_app_biometry_request_auth":
    case "web_app_biometry_update_token":
      return h("7.2", e);
    case "web_app_setup_swipe_behavior":
      return h("7.7", e);
    case "web_app_share_to_story":
      return h("7.8", e);
    case "web_app_setup_secondary_button":
    case "web_app_set_bottom_bar_color":
      return h("7.10", e);
    case "web_app_request_safe_area":
    case "web_app_request_content_safe_area":
    case "web_app_request_fullscreen":
    case "web_app_exit_fullscreen":
    case "web_app_set_emoji_status":
    case "web_app_add_to_home_screen":
    case "web_app_check_home_screen":
    case "web_app_request_emoji_status_access":
    case "web_app_check_location":
    case "web_app_open_location_settings":
    case "web_app_request_file_download":
    case "web_app_request_location":
    case "web_app_send_prepared_message":
    case "web_app_start_accelerometer":
    case "web_app_start_device_orientation":
    case "web_app_start_gyroscope":
    case "web_app_stop_accelerometer":
    case "web_app_stop_device_orientation":
    case "web_app_stop_gyroscope":
    case "web_app_toggle_orientation_lock":
      return h("8.0", e);
    default:
      return [
        "iframe_ready",
        "iframe_will_reload",
        "web_app_close",
        "web_app_data_send",
        "web_app_expand",
        "web_app_open_link",
        "web_app_ready",
        "web_app_request_theme",
        "web_app_request_viewport",
        "web_app_setup_main_button",
        "web_app_setup_closing_behavior"
      ].includes(t);
  }
}
function vn(t, e) {
  e || (e = "strict");
  const n = typeof e == "function" ? e : (r) => {
    const { method: s, version: a } = r, i = "param" in r ? new Qt(s, r.param, a) : new Ht(s, a);
    if (e === "strict")
      throw i;
    return console.warn(i.message);
  };
  return (r, s) => we(r, t) ? r === "web_app_set_header_color" && /* @__PURE__ */ D(/* @__PURE__ */ v({ color: /* @__PURE__ */ ke() }), s) && !we(r, "color", t) ? n({ version: t, method: r, param: "color" }) : Ze(r, s) : n({ version: t, method: r });
}
function wn(t, e, n, r) {
  return Xe("web_app_invoke_custom_method", "custom_method_invoked", {
    ...r || {},
    params: { method: t, params: e, req_id: n },
    capture: on(n)
  }).then(({ result: s, error: a }) => {
    if (a)
      throw new tn(a);
    return s;
  });
}
function En() {
  Kt(), zt(!1), Q.unsubAll(), Q.reset();
}
export {
  Vt as InvalidLaunchParamsError,
  tn as InvokeCustomMethodError,
  Xt as LaunchParamsRetrieveError,
  Qt as MethodParameterUnsupportedError,
  Ht as MethodUnsupportedError,
  en as UnknownEnvError,
  on as captureSameReq,
  un as compareVersions,
  vn as createPostEvent,
  ye as emitEvent,
  Pe as hasWebviewProxy,
  wn as invokeCustomMethod,
  Se as isIframe,
  _n as isInvalidLaunchParamsError,
  bn as isInvokeCustomMethodError,
  dn as isLaunchParamsRetrieveError,
  fn as isMethodMethodParameterUnsupportedError,
  ln as isMethodUnsupportedError,
  hn as isTMA,
  yn as isUnknownEnvError,
  mn as mockTelegramEnv,
  Bt as off,
  Kt as offAll,
  Qe as on,
  Ze as postEvent,
  Xe as request,
  En as resetPackageState,
  an as retrieveLaunchParams,
  gn as retrieveRawInitData,
  Ve as retrieveRawLaunchParams,
  zt as setDebug,
  we as supports,
  Q as targetOrigin
};
//# sourceMappingURL=index.js.map
